var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63898 12.2682L5.83341 18.3333L9.65708 16.0391C9.78179 15.9643 9.84415 15.9269 9.91071 15.9122C9.96959 15.8993 10.0306 15.8993 10.0895 15.9122C10.156 15.9269 10.2184 15.9643 10.3431 16.0391L14.1667 18.3333L13.362 12.2677M15.8334 7.49996C15.8334 10.7216 13.2217 13.3333 10.0001 13.3333C6.77842 13.3333 4.16675 10.7216 4.16675 7.49996C4.16675 4.2783 6.77842 1.66663 10.0001 1.66663C13.2217 1.66663 15.8334 4.2783 15.8334 7.49996Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.63de0cc8e063d0e08c56bd1962440726.svg";
export { ForwardRef as ReactComponent };